/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Error_TitleInputs */

const en_gc_editor_error_title = /** @type {(inputs: Gc_Editor_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your workspace is taking a moment.`)
};

const zh_gc_editor_error_title = /** @type {(inputs: Gc_Editor_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作区启动需要一点时间。`)
};

/**
* | output |
* | --- |
* | "Your workspace is taking a moment." |
*
* @param {Gc_Editor_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_error_title = /** @type {((inputs?: Gc_Editor_Error_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Error_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_error_title(inputs)
	return zh_gc_editor_error_title(inputs)
});
export { gc_editor_error_title as "gc.editor.error_title" }